import {NgModule} from '@angular/core';

import {PerfectScrollbarDirective} from '@theme/directives/perfect-scrollbar/perfect-scrollbar.directive';

@NgModule({
  declarations: [
    PerfectScrollbarDirective
  ],
  imports: [],
  exports: [
    PerfectScrollbarDirective
  ]
})
export class DirectivesModule {
}
